import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'

import { NETWORK_GROWTH_HISTOGRAM_HEIGHT } from 'components/reports/Metrics/constants'

import { NetworkGrowthHistogram } from '../types'
import { JobsPerSupplierChart } from './JobsPerSupplierChart'

interface Props {
  title: string
  subtitle: string
  totalCaption: string
  color: string
  info?: string
  histogram?: NetworkGrowthHistogram | null
  loading?: boolean
}

export const JobsPerSupplierCard = ({
  title,
  subtitle,
  totalCaption,
  color,
  info,
  histogram,
  loading,
}: Props) => (
  <Paper
    variant='outlined'
    sx={{ p: 2.5, height: '100%', borderRadius: 2, borderTop: `3px solid ${color}` }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1}
      justifyContent='space-between'
      alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
      mb={2}>
      <Stack>
        <Stack direction='row' spacing={1} alignItems='center'>
          <Typography variant='subtitle1' fontWeight={600}>
            {title}
          </Typography>
          {info && (
            <Tooltip title={info}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          )}
        </Stack>
        <Typography variant='body2' color='primary.main'>
          {subtitle}
        </Typography>
      </Stack>

      <Stack alignItems={{ xs: 'flex-start', sm: 'flex-end' }}>
        <Typography variant='caption' color='text.secondary'>
          {totalCaption}
        </Typography>
        {loading ? (
          <Skeleton width={60} height={32} />
        ) : (
          <Typography variant='h6' fontWeight={700}>
            {(histogram?.totalSuppliers ?? 0).toLocaleString()}
          </Typography>
        )}
      </Stack>
    </Stack>

    {loading ? (
      <Skeleton
        variant='rectangular'
        height={NETWORK_GROWTH_HISTOGRAM_HEIGHT}
        sx={{ borderRadius: 1 }}
      />
    ) : (
      <JobsPerSupplierChart buckets={histogram?.buckets ?? []} color={color} />
    )}

    <Typography variant='caption' color='text.secondary' display='block' mt={1}>
      Suppliers with 0 completed jobs are not shown.
    </Typography>
  </Paper>
)
